<template>
    <v-container>
            <v-row align="center" justify="center">
                <v-col cols="12" class="text-center">
                    <h1>Hola, {{ user.names | capitalize }}</h1>
                </v-col>
            </v-row>

            <v-row align="center" justify="center" v-if="!user.authorized">
                <v-col lg="6" md="10" sm="12" class="mt-5 elevation-2 red lighten-2 text-white">
                    <h2 class="white--text">¡Espera!</h2>
                    <h3 class="white--text">Tú información aún está siendo validada, por lo general esto tarda unos minutos. Si la información es correcta, nuestro personal se pondrá en contacto contigo.</h3>
                </v-col>
            </v-row>

            <v-row align="center" justify="center">
                <v-col lg="6" md="10" sm="12" class="mt-5 elevation-2">
                    <h3>Mis cursos</h3>
                    <v-row align="center" justify="center">
                        <v-col lg="6" md="6" sm="12">
                            <div class="text-center" v-if="courses == 0">
                                <h2 class="mb-3" >Aún no se ha asignado ningún curso</h2>
                                <v-btn outlined color="#000" href="/assigned-courses">Mis cursos asignados</v-btn>
                            </div>

                            <div class="text-center" v-else>
                                <h2 class="mb-1">Total de cursos asignados:</h2>
                                <h2>{{ courses }}</h2>
                                <v-btn outlined color="#000" class="mt-4" href="/assigned-courses">Mis cursos asignados</v-btn>
                            </div>
                        </v-col>
                        <v-col lg="6" md="6" sm="12">
                            <v-img src="/images/curso.png" fluid></v-img>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
    </v-container>
</template>
<script>
export default {
    props:['user', 'courses'],
    filters:{
        capitalize: function (value) {
            if (!value) return ''
            value = value.toString()
            return value.charAt(0).toUpperCase() + value.slice(1)
        }
    },
}
</script>
